import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';

const defaultBenefits = [
  'Machine Cost',
  'Filter Charges',
  'Service Charges',
  'Installation Fee',
  'AMC Charges',
  'Technician Visits',
];

const RentBanner = ({ cms }) => {
  const navigate = useNavigate();
  const d = cms || {};
  const title = d.title || 'RO Water Purifier';
  const highlight = d.highlight_text || 'On Rent from \u20B9350/mo';
  const subtitle = d.subtitle || 'Zero Investment Plan';
  const description = d.content || 'Premium alkaline RO purifier with zero maintenance cost. All services and filters included.';
  const ctaText = d.cta_text || 'View Rental Plans';
  const benefits = d.benefits || d.items || defaultBenefits;

  return (
    <section className="py-14 md:py-20 bg-gradient-to-br from-[#0f2847] to-[#0a1628] reveal-on-scroll" data-testid="rent-banner-section">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center max-w-5xl mx-auto">
          <div>
            <p className="text-lime-400 text-xs sm:text-sm font-semibold uppercase tracking-wider mb-3">{subtitle}</p>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-3 md:mb-4 leading-tight">
              {title}
              <br />
              <span className="text-lime-400">{highlight}</span>
            </h2>
            <p className="text-sm sm:text-base text-blue-200/60 mb-6">
              {description}
            </p>
            <Button
              onClick={() => navigate('/ro-on-rent')}
              data-testid="rent-banner-cta"
              className="bg-lime-500 hover:bg-lime-400 text-gray-900 px-7 sm:px-8 py-5 sm:py-6 text-base sm:text-lg rounded-xl font-bold group"
            >
              {ctaText}
              <ArrowRight size={18} className="ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>

          <div className="grid grid-cols-2 gap-x-4 gap-y-3">
            {benefits.map((item, i) => {
              const text = typeof item === 'string' ? item : (item.text || item.title || item.label || '');
              return (
              <div key={i} className="flex items-center gap-2.5 text-white/80 text-xs sm:text-sm">
                <CheckCircle className="text-lime-400 shrink-0" size={16} />
                <span><span className="text-lime-400 font-bold">{'\u20B9'}0</span> {text}</span>
              </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default RentBanner;
